(function ($) {
  var elementorHookRegistered = false;

  function addToPlaceholder(letter, $field) {
    $field.attr('placeholder', ($field.attr('placeholder') || '') + letter);

    return new Promise(function (resolve) {
      setTimeout(resolve, 100);
    });
  }

  function clearPlaceholder($field) {
    $field.attr('placeholder', '');
  }

  function stopPlaceholderLoop($banner) {
    var timer = $banner.data('hero-banner-placeholder-timer');

    if (timer) {
      clearTimeout(timer);
      $banner.removeData('hero-banner-placeholder-timer');
    }
  }

  function parsePhrases($target) {
    var rawValue = $target.val();
    var searchFields;

    if (!rawValue) {
      return [];
    }

    try {
      searchFields = JSON.parse(decodeURIComponent(rawValue));
    } catch (error) {
      return [];
    }

    if (!Array.isArray(searchFields)) {
      return [];
    }

    return searchFields
      .map(function (phrase) {
        return phrase && phrase.textes ? phrase.textes : '';
      })
      .filter(function (phrase) {
        return phrase.length;
      });
  }

  function printPhrase($banner, phrase, $field) {
    return new Promise(function (resolve) {
      var letters = phrase.split('');

      clearPlaceholder($field);

      letters.reduce(function (promise, letter, index) {
        return promise.then(function () {
          if (index === letters.length - 1) {
            $banner.data(
              'hero-banner-placeholder-timer',
              setTimeout(resolve, 1000)
            );
          }

          return addToPlaceholder(letter, $field);
        });
      }, Promise.resolve());
    });
  }

  function printPhrases($banner, phrases, $field) {
    if (!$banner.data('hero-banner-placeholder-active')) {
      return;
    }

    phrases.reduce(function (promise, phrase) {
      return promise.then(function () {
        return printPhrase($banner, phrase, $field);
      });
    }, Promise.resolve()).then(function () {
      if (!$banner.data('hero-banner-placeholder-active')) {
        return;
      }

      $banner.data(
        'hero-banner-placeholder-timer',
        setTimeout(function () {
          printPhrases($banner, phrases, $field);
        }, 1000)
      );
    });
  }

  function initHeroBanner($scope) {
    var $banner = $scope.is('[data-hero-banner]')
      ? $scope
      : $scope.find('[data-hero-banner]').first();

    if (!$banner.length) {
      return;
    }

    var $target = $banner.find('[data-hero-banner-search-texts]').first();
    var $field = $banner.find('.searchbar').first();
    var phrases = parsePhrases($target);

    stopPlaceholderLoop($banner);
    $banner.data('hero-banner-placeholder-active', false);

    if (!$target.length || !$field.length || !phrases.length) {
      return;
    }

    $banner.data('hero-banner-placeholder-active', true);
    printPhrases($banner, phrases, $field);
  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;
    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/hero-banner.default',
      initHeroBanner
    );
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();

    $('.elementor-widget-hero-banner').each(function () {
      initHeroBanner($(this));
    });
  });
})(jQuery);
